import { db } from '@/store/firebase'
import firestoUtils from '@/utils/firestore'
// import store from '@/store'

export default {
  async findByField (fieldId, companyId) {
    const doc = await db.doc(`formFields/${companyId}/fields/${fieldId}`)
      .get()

    if (doc.exists) return firestoUtils.docToObject(doc)

    return null
  },
  async addItem (fieldId, companyId, payload) {
    const formFieldRef = db.doc(`formFields/${companyId}/fields/${fieldId}`)
    return db.runTransaction(async transaction => {
      const doc = await transaction.get(formFieldRef)
      const data = doc.data()
      let oldItems = data && data.items ? data.items : []

      await transaction.set(formFieldRef, {
        items: [...oldItems, payload]
      }, { merge: true })
    })
  },
  async delItem (fieldId, companyId, payload) {
    const formFieldRef = db.doc(`formFields/${companyId}/fields/${fieldId}`)
    return db.runTransaction(async transaction => {
      const doc = await transaction.get(formFieldRef)
      const data = doc.data()
      let oldItems = data && data.items ? data.items : []

      await transaction.set(formFieldRef, {
        items: oldItems.filter(item => item !== payload)
      }, { merge: true })
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/formFields.js